import { useState } from 'react'
import { Suspense } from 'react'
import dynamic from 'next/dynamic'
import Image from 'next/image'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import style from './currentCoinComponent.module.css'
import { singleItem } from '../../../constants/mainFunctions';
const LoadingComponent = dynamic(() => import('../../shared/loadingComponent'))
const CurrentCoinTab = dynamic(() => import('./currentCoinTab'), { suspense: true })
const ModalCoinImage = dynamic(() => import('../../modals/modalCoinImage'))


export default function CurrentCoinMainComponent(data) {

    const { item } = singleItem(data)
    const [imgName, setImgName] = useState('')
    const [myAlt, setMyAlt] = useState('')
    const [show, setShow] = useState(false)

    if (!item?.data) {
        return (<LoadingComponent />)
    }
    const handleClose = () => {
        setShow(false)
    }

    const myLoader = ({ src, width, quality }) => {
        return `${src}?w=${width}&q=${quality || 75}`
    }

    //const myLoader2 = ({ src, width, quality }) => {
    //    return `https://www.webwiki.com/etc/rating/widget/1380893098/${src}?w=${width}&q=${quality || 75}`
    //}

    return (<>
        <article className='sectionOrArticleTB' >
            <ModalCoinImage
                show={show}
                handleClose={handleClose}
                imageName={imgName}
                alt={myAlt}
            />
            <div className='text-center'>
                <h1 className='caregoriesTitle'>{item?.data ? item?.data?.title : null}</h1>
            </div>
            <div className='imgStripContainer'>
                <div className='imgStripText'>
                    <Image src='/images/Strip1.gif'
                        alt="Strip"
                        fill
                        sizes="(max-width: 768px) 100vw,
                     (max-width: 1200px) 50vw,
                     33vw"
                    />
                </div>
            </div>
        </article>
        <article className='sectionOrArticleTB mt-5 mt-lg-0 mt-xl-0 ' style={{ position: 'relative' }}>
            <Container >
                <Row className='justify-content-center  justify-content-md-start pt-1 pt-md-3 pt-lg-4'>
                    <Col xs={12} sm={6} md={6} lg={5}>
                        <Row>
                            <Col xs={3} className='gy-0 gx-0 px-1'>
                                <article>
                                    {item?.data ? item?.data?.image2 && <div className={style.container} onClick={async () => {
                                        await setImgName(`${item?.data?.image2}`)
                                        await setMyAlt(`${item?.data?.description}`)
                                        await setShow(true)
                                    }}>
                                        <div className={style.text}>
                                            <Image src={`${item?.data?.image2}`}
                                                loader={myLoader}
                                                alt={item?.data?.title || 'FLGCE item image'}
                                                fill
                                                sizes="(max-width: 768px) 100vw,
                                        (max-width: 1200px) 50vw,
                                        33vw"
                                                quality={70}
                                                className='cardImage'
                                            />
                                        </div>
                                    </div> : null}
                                </article>

                                <article>
                                    {item?.data ? item?.data?.image3 && <div className={style.container} onClick={async () => {
                                        await setImgName(`${item?.data?.image3}`)
                                        await setMyAlt(`${item?.data?.title}`)
                                        await setShow(true)
                                    }} >
                                        <div className={style.text}>
                                            <Image src={`${item?.data?.image3}`}
                                                loader={myLoader}
                                                alt={item?.data?.title || 'FLGCE item image'}
                                                fill
                                                sizes="(max-width: 768px) 100vw,
                                        (max-width: 1200px) 50vw,
                                        33vw"
                                                quality={70}
                                                className='cardImage'
                                            />
                                        </div>
                                    </div> : null}
                                </article>

                                <article>
                                    {item?.data ? item?.data?.image4 && <div className={style.container} onClick={async () => {
                                        await setImgName(`${item?.data?.image4}`)
                                        await setMyAlt(`${item?.data?.title}`)
                                        await setShow(true)
                                    }}>
                                        <div className={style.text}>
                                            <Image src={`${item?.data?.image4}`}
                                                loader={myLoader}
                                                alt={item?.data?.title || 'FLGCE item image'}
                                                fill
                                                sizes="(max-width: 768px) 100vw,
                                        (max-width: 1200px) 50vw,
                                        33vw"
                                                quality={70}
                                                className='cardImage'
                                            />
                                        </div>
                                    </div> : null}
                                </article>

                                <article>
                                    {item?.data ? item?.data?.image5 && <div className={style.container} onClick={async () => {
                                        await setImgName(`${item?.data?.image5}`)
                                        await setMyAlt(`${item?.data?.title}`)
                                        await setShow(true)
                                    }}>
                                        <div className={style.text}>
                                            <Image src={`${item?.data?.image5}`}
                                                loader={myLoader}
                                                alt={item?.data?.title || 'FLGCE item image'}
                                                fill
                                                sizes="(max-width: 768px) 100vw,
                                        (max-width: 1200px) 50vw,
                                        33vw"
                                                quality={70}
                                                className='cardImage'
                                            />
                                        </div>
                                    </div> : null}
                                </article>

                                <article>
                                    {item?.data ? item?.data?.image6 && <div className={style.container} onClick={async () => {
                                        await setImgName(`${item?.data?.image6}`)
                                        await setMyAlt(`${item?.data?.title}`)
                                        await setShow(true)
                                    }} >
                                        <div className={style.text}>
                                            <Image src={`${item?.data?.image6}`}
                                                loader={myLoader}
                                                alt={item?.data?.title || 'FLGCE item image'}
                                                fill
                                                sizes="(max-width: 768px) 100vw,
                                        (max-width: 1200px) 50vw,
                                        33vw"
                                                quality={70}
                                                className='cardImage'
                                            />
                                        </div>
                                    </div> : null}
                                </article>

                                <article>
                                    {item?.data ? item?.data?.image7 && <div className={style.container} onClick={async () => {
                                        await setImgName(`${item?.data?.image7}`)
                                        await setMyAlt(`${item?.data?.title}`)
                                        await setShow(true)
                                    }}>
                                        <div className={style.text}>
                                            <Image src={`${item?.data?.image7}`}
                                                loader={myLoader}
                                                alt={item?.data?.title || 'FLGCE item image'}
                                                fill
                                                sizes="(max-width: 768px) 100vw,
                                        (max-width: 1200px) 50vw,
                                        33vw"
                                                quality={70}
                                                className='cardImage'
                                            />
                                        </div>
                                    </div> : null}
                                </article>

                                <article>
                                    {/*<a title="Customer reviews of flgoldcoinexchange.com"*/}
                                    {/*    target='_blank'*/}
                                    {/*    rel='noopener noreferrer nofollow'*/}
                                    {/*    href="https://www.webwiki.com/flgoldcoinexchange.com">*/}
                                    {/*    <div className={style.container}>*/}
                                    {/*        <div className={style.text}>*/}
                                    {/*            <Image src="flgoldcoinexchange-com-rating-full-180.png"*/}
                                    {/*                loader={myLoader2}*/}
                                    {/*                alt="Reviews of flgoldcoinexchange.com"*/}
                                    {/*                fill*/}
                                    {/*                sizes="(max-width: 768px) 100vw,*/}
                                    {/*    (max-width: 1200px) 50vw,*/}
                                    {/*    33vw"*/}
                                    {/*                quality={70}*/}
                                    {/*                className='cardImage'*/}
                                    {/*            />*/}
                                    {/*        </div>*/}
                                    {/*    </div>*/}
                                    {/*    */}{/*<img src="https://www.webwiki.com/etc/rating/widget/1380893098/flgoldcoinexchange-com-rating-full-180.png"*/}
                                    {/*    */}{/*    alt="Reviews of flgoldcoinexchange.com" />*/}
                                    {/*</a>*/}
                                </article>

                            </Col>

                            <Col xs={9} className='gy-0 gx-0 px-1 px-md-2' >
                                <article>
                                    {item?.data ? <div className={style.container} onClick={async () => {
                                        await setImgName(`${item?.data?.image1}`)
                                        await setMyAlt(`${item?.data?.title}`)
                                        await setShow(true)
                                    }}>
                                        <div className={style.text}>
                                            <Image src={`${item?.data?.image1}`}
                                                loader={myLoader}
                                                alt={item?.data?.title || 'FLGCE item image'}
                                                fill
                                                sizes="(max-width: 768px) 100vw,
                                        (max-width: 1200px) 50vw,
                                        33vw"
                                                quality={70}
                                                className='cardImage'
                                            />
                                        </div>
                                    </div> : null}
                                </article>
                            </Col>
                        </Row>
                    </Col>

                    <Col xs={12} sm={6} md={6} lg={7}>
                        <Suspense fallback={<LoadingComponent />}>
                            <CurrentCoinTab
                                data={item}
                            />
                        </Suspense>
                    </Col>
                </Row>
            </Container>
            <Container>
                <Row>
                    <Col>
                        <div className='text-center'>
                            <h4 className='caregoriesTitle ml-0'>Price: <span className={style.price}>US {Number(item?.data?.price).toLocaleString('en-US', { style: 'currency', currency: 'USD' })}</span></h4>
                        </div>
                    </Col>
                </Row>
            </Container>
        </article>
    </>
    )
}